import {SptSystemInformation} from '@spout/any-shared/models';

export function getDesktopSerialNumber(desktopInformation: SptSystemInformation) {
  // return desktopInformation.system.serial;
  return '';
}
